import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import XHR from "i18next-xhr-backend";

import translationDe from "./locales/de/translation.json";

i18n
  // .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: "de",
    fallbackLng: "de",

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      de: {
        translations: translationDe,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;